import Vue from 'vue'
import Vuex from 'vuex'
import { login as apiLogin, logout as apiLogout } from '@/api/auth'
import { smsBalance } from '@/api/sms'

Vue.use(Vuex)

// 从 localStorage 恢复登录用户（刷新后保留）
function loadUser() {
  try {
    return JSON.parse(localStorage.getItem('crm_user') || 'null')
  } catch (e) {
    return null
  }
}

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('crm_token') || '',
    user: loadUser(),
    // 短信模块是否启用（后台开关），控制机构端短信菜单显隐；默认 true 避免首次渲染抖动
    smsEnabled: true
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('crm_token', token)
    },
    setUser(state, user) {
      state.user = user
      localStorage.setItem('crm_user', JSON.stringify(user))
    },
    setSmsEnabled(state, enabled) {
      state.smsEnabled = !!enabled
    },
    clearAuth(state) {
      state.token = ''
      state.user = null
      state.smsEnabled = true
      localStorage.removeItem('crm_token')
      localStorage.removeItem('crm_user')
    }
  },
  actions: {
    // 登录成功后保存会话
    setSession({ commit }, { token, user }) {
      commit('setToken', token)
      commit('setUser', user)
    },
    // 拉取短信模块启用状态（关闭时机构端隐藏短信菜单）
    async loadSmsFeature({ commit }) {
      try {
        const data = await smsBalance()
        commit('setSmsEnabled', data && data.enabled !== false)
      } catch (e) {
        // 无权限/异常不判定为关闭，避免误隐藏
        commit('setSmsEnabled', true)
      }
    },
    async login({ commit }, form) {
      const data = await apiLogin(form)
      commit('setToken', data.token)
      commit('setUser', data)
      return data
    },
    async logout({ commit }) {
      try {
        await apiLogout()
      } catch (e) { /* 忽略退出失败 */ }
      commit('clearAuth')
    }
  }
})
